<template>
    <ul class="ais-Menu-list">
        <li class="menu-prefix">Filter:</li>
        <li>
            <AlgoliaSearchClear included-attributes="categories.lvl0">
                <span class="menu-prefix menu-prefix--button">ALL</span>
            </AlgoliaSearchClear>
        </li>
        <li
            v-for="item in sortedCategories"
            :key="item.value"
            class="ais-Menu-item"
            :class="{'ais-Menu-item--selected': item.isRefined}"
        >
            <a
                class="ais-Menu-link"
                @click.prevent="refine(item.value)"
            >
                {{ item.label }}
            </a>
        </li>
    </ul>
</template>
<script>

export default {
    name: 'AlgoliaEventsCategories',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        refine: {
            type: Function
        }
    },
    data() {
        return {
            sortingMap: {
                'Lifestyle': 1,
                'Festivals & Celebrations': 2,
                'Eat & Drink': 3,
                'Markets': 4,
                'Arts, Culture & Heritage': 5,
                'Sports & Adventure': 6
            }
        };
    },
    computed: {
        sortedCategories() {
            return [...this.items].sort((a, b) => {
                return this.sortingMap[a.label] - this.sortingMap[b.label]
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.ais-Menu-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    @include media-query(desk) {
        flex-wrap: no-wrap;
    }
}

::v-deep .ais-Menu-item, .menu-prefix {
    display: flex;
    font-size: 16px;
    font-weight: 600;
    color: getColour("grey", "dark");
    margin-right: 20px;
    padding: 10px;
    cursor: pointer;
}

::v-deep .menu-prefix--button {
    cursor: pointer;
}

::v-deep .is-active > .menu-prefix {
    border-radius: 20px;
    background-color: getColour("lightblue", "dark");
    color: #fff;
}

::v-deep .ais-Menu-item--selected {
    border-radius: 20px;
    background-color: getColour("lightblue", "dark");
    color: #fff;
}

::v-deep .ais-Menu-link {
    text-transform: uppercase;
    white-space: nowrap;
}
</style>
